export const siteNav = [
  { path: '/', label: '首页' },
  { path: '/guide', label: '访问指南' },
  { path: '/topics', label: '热门话题' },
  { path: '/faq', label: '常见问题' },
  { path: '/about', label: '关于我们' },
];